<span [class]="'tooltip ' + arrowClass" [ngClass]="{'ready': isReady&&checkedPosition, 'has-header': !!label, 'tooltip-padding':  tooltipPadding}" cpClickOut [clickOutDisable]="disableClickOut" (clickOut)="onClickOut($event)">
	<kendo-popup #popup *ngIf="isTooltipOpen"
               [popupClass]="arrowClass + ' ' + tooltipID"
               [anchor]="anchor"
               [offset]="offset"
               [anchorAlign]="anchorAlign"
               [popupAlign]="popupAlign"
               [collision]="collision"
               [animate]="false"
               (close)="onClose($event)"
               (open)="onOpen($event)"
               (mouseenter)="onPopupMouseEnter()"
               (mouseleave)="onPopupMouseLeave($event)">
		<div class="header" *ngIf="label">
			<span>{{ label | cpTitleTranslate }}</span>
		</div>
		<div class="tooltip-content" [style.width]="width" [style.height]="height" [style.padding.px]="contentPadding">
			<ng-content></ng-content>
		</div>
	</kendo-popup>
</span>

